<template>
  <div class="row">
    <div class="col">
      <dashboard-content></dashboard-content>
    </div>
  </div>
</template>
<script>
    import DashboardContent from './Content.1.vue'

    export default {
        components: {
            DashboardContent,
        }

    }
</script>
